import React, { useState } from 'react';
import Avatar from './Avatar';
import { FaPencilAlt } from 'react-icons/fa';
import { useSocket } from '../context/chats/socket/SocketContext';
import GroupAvatarEditor from './GroupAvatarEditor';

const ChatInfo = ({
    selectedChat,
    onBack,
    onDeleteChat,
    selectedUser,
    setInspectedUser,
    removeFromGroup,
    onAddMembers,
    onlineUsers,
    handlePermissionChange,
    setSelectedChat,
    setMessages,
    setLocalChatList,
    selectedAvatar,
    setSelectedAvatar,
    setGroups
}) => {
    const socket = useSocket();
    const { avatar, username, bio, date, isGroupChat, chatName, groupAdmin = [] } = selectedChat;

    const [editingName, setEditingName] = useState(false);
    const [newGroupName, setNewGroupName] = useState(isGroupChat ? chatName : username);
    const [renamingLoading, setRenamingLoading] = useState(false);

    const host = process.env.REACT_APP_BACKEND_URL;


    let isOnline = onlineUsers.has(selectedChat.otherUserId) ? true : false;

    const currentUserId = localStorage.getItem('userId');
    const isAdmin = groupAdmin.some(admin => admin._id === currentUserId);

    const formatDate = (dateStr) => {
        if (!dateStr) return 'N/A';
        const date = new Date(dateStr);
        return date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    // useEffect(() => {
    //     setNewGroupName(chatName)
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [socket])


    // inside ChatInfo component
    const handleRenameGroup = async () => {
        if (!newGroupName.trim()) return;

        setRenamingLoading(true);
        try {
            const res = await fetch(`${host}/api/chat/rename/${selectedChat._id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': localStorage.getItem('token')
                },
                body: JSON.stringify({ chatName: newGroupName })
            });

            const data = await res.json();
            if (res.ok) {
                selectedChat.chatName = data.chatName; // update locally
                setEditingName(false);

                if (data.populatedSystemMessage) {
                    const systemMessage = {
                        ...data,
                        content: data.populatedSystemMessage.content,
                        type: 'system', // handle this in MessageBox styling
                        createdAt: new Date().toISOString(),
                        chat: data.chat,
                        users: data.users,
                        isSystem: true

                    };
                    if (socket) {
                        socket.emit('send-message', systemMessage);
                    }
                    
                }
            } else {
                alert(data.error || "Failed to rename group");
            }
        } catch (err) {
            console.error(err);
            alert("Something went wrong");
        } finally {
            setRenamingLoading(false);
        }
    };

    const onRemoveUser = (id) => {
        removeFromGroup(selectedChat._id, [id]);
    };

    // Move current user to the top
    const sortedMembers = [...(selectedChat.users || [])].sort((a, b) => {
        if (a._id === currentUserId) return -1;
        if (b._id === currentUserId) return 1;
        return 0;
    });

    const formatName = (str) => {
        
        return str
            // Insert space before capital letters
            .replace(/([A-Z])/g, ' $1')
            // Trim leading/trailing spaces
            .trim()
            // Capitalize first letter of each word
            .replace(/\b\w/g, char => char.toUpperCase());
    }

    if (!selectedChat) return null;


    return (
        <div className="p-4 text-white d-flex flex-column">
            <button
                className="btn btn-light mb-4"
                onClick={onBack}
                style={{ alignSelf: 'flex-start' }}
            >
                ← Back to Chat
            </button>

            <div className="d-flex flex-column align-items-center mb-4">

                {!isGroupChat && <Avatar src={avatar} size={120} isGroup={isGroupChat} isOnline={isOnline} name={username} />}
                {isGroupChat && <GroupAvatarEditor selectedChat={selectedChat} isOnline={isOnline} setSelectedChat={setSelectedChat} showCamera={true} selectedAvatar={selectedAvatar} onAvatarChange={(newAvatar) => {
                    // Update the sidebar immediately
                    setGroups(prev =>
                        prev.map(g =>
                            g._id === selectedChat._id ? { ...g, avatar: newAvatar } : g
                        )
                    );
                }} setSelectedAvatar={setSelectedAvatar} />}

                <h3 className="mt-3 text-center d-flex align-items-center justify-content-center gap-2">
                    {editingName ? (
                        <>
                            <div>
                                <input
                                    type="text"
                                    value={newGroupName}
                                    onChange={(e) => setNewGroupName(e.target.value)}
                                    className="form-control form-control-sm"
                                    disabled={renamingLoading}
                                />
                                <div style={{ fontSize: '1rem', color: (newGroupName?.length < 3 || newGroupName?.length > 30) ? 'red' : 'black' }}>
                                    {newGroupName.length}/30
                                </div>
                            </div>
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={handleRenameGroup}
                                disabled={renamingLoading || newGroupName?.length < 3 || newGroupName?.length > 30}
                            >
                                Save
                            </button>
                            <button
                                className="btn btn-sm btn-secondary"
                                onClick={() => { setEditingName(false); setNewGroupName(chatName); }}
                                disabled={renamingLoading}
                            >
                                Cancel
                            </button>

                        </>
                    ) : (
                        <>
                            {chatName}
                            {(isAdmin || selectedChat?.permissions?.rename === 'all') && (
                                <FaPencilAlt
                                    style={{ cursor: 'pointer', fontSize: '1.5rem' }}
                                    onClick={() => setEditingName(true)}
                                />
                            )}
                        </>
                    )}
                </h3>

                {bio && (
                    <p className="text-center mt-2" style={{ fontStyle: 'italic', opacity: 0.8 }}>
                        {bio}
                    </p>
                )}
            </div>

            <div className="flex-grow-1 overflow-auto w-100">
                {isGroupChat ? (
                    <>
                        
                        {isAdmin && (
                            <div className="mt-3">
                                <h5>Group Permissions</h5>
                                {Object.keys((selectedChat.permissions) || {}).map((permKey) => (
                                    <div key={permKey} className="mb-2">
                                        <label className="form-label">{formatName(permKey)}</label>
                                        <select
                                            className="form-select"
                                            value={selectedChat.permissions[permKey]}
                                            onChange={(e) =>
                                                handlePermissionChange(permKey, e.target.value)
                                            }
                                        >
                                            <option value="admin">Admin Only</option>
                                            <option value="all">Everyone</option>
                                        </select>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Multiple Group Admins */}
                        <div className="mb-3">
                            <strong>Group Admin(s):</strong>
                            <div className="d-flex flex-wrap gap-2 mt-2">
                                {groupAdmin.length > 0 ? (
                                    groupAdmin.map(admin => (
                                        <div key={admin._id} className="d-flex flex-column align-items-center gap-2">
                                            <Avatar src={admin.avatar} width="4" height="4" size="14" isGroup={false} isOnline={onlineUsers?.has?.(admin._id) ?? false} name={admin?.username} />
                                            <span>{admin.username}</span>
                                        </div>
                                    ))
                                ) : (
                                    <span> N/A </span>
                                )}
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                            <strong>Members ({selectedChat.users?.length || 0}):</strong>
                            {(isAdmin || selectedChat?.permissions?.addUser === 'all') && (
                                <button className="btn btn-sm btn-success" onClick={onAddMembers}>
                                    + Add Members
                                </button>
                            )}
                        </div>

                        <ul
                            className="list-unstyled mt-2"
                            style={{ maxHeight: 200, overflowY: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                        >
                            {sortedMembers.map((u) => (
                                <li
                                    key={u._id}
                                    className="mb-2 d-flex align-items-center justify-content-between"
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div
                                        className="d-flex align-items-center gap-2 w-100"
                                        style={{
                                            border: '1px solid white',
                                            borderRadius: '6px',
                                            padding: '6px',
                                            backgroundColor: u._id === currentUserId ? '#222' : 'transparent'
                                        }}
                                        onClick={() => setInspectedUser(u)}
                                    >
                                        <Avatar
                                            src={u?.avatar}
                                            width="4"
                                            height="4"
                                            size="14"
                                            isGroup={false}
                                            isOnline={onlineUsers?.has?.(u._id) ?? false}
                                            name={u?.username}
                                        />
                                        <span>
                                            {u.username}
                                            {u._id === currentUserId && ' (You)'}
                                        </span>
                                    </div>

                                    {(isAdmin || selectedChat?.permissions?.removeUser === 'all') &&
                                        u._id !== currentUserId && (
                                            <button
                                                className="btn btn-sm btn-danger ms-2"
                                                onClick={() => {
                                                    if (window.confirm(`Remove ${u.username} from the group?`)) {
                                                        onRemoveUser(u._id);
                                                    }
                                                }}
                                            >
                                                ❌
                                            </button>
                                        )}
                                </li>
                            ))}
                        </ul>

                    </>
                ) : (
                    <>
                        <div className="mb-2">
                            <strong>Status:</strong> <span>{isOnline ? 'Online' : 'Offline'}</span>
                        </div>
                        <div className="mb-2">
                            <strong>Date Joined:</strong> <span>{formatDate(date)}</span>
                        </div>
                    </>
                )}
            </div>

            <button
                className="btn btn-danger mt-auto"
                onClick={() => {
                    if (window.confirm(`Are you sure you want to delete the chat with ${isGroupChat ? chatName : username}? This action cannot be undone.`)) {
                        onDeleteChat(selectedChat._id);
                    }
                }}
            >
                Delete Chat
            </button>
        </div>
    );
};

export default ChatInfo;
